import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Loader from '@wix/da-ds/pkg/Loader';
import s from './FakeFilmThumb.scss';

export interface Props {
  className?: string;
}

const FakeFilmThumb: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['content']}>
        <Loader size="big" state="popcorn" />
        <div className={s['title']}>
          {t('deviationSubmit.form.preview.film.title')}
        </div>
        <div className={s['subtitle']}>
          {t('deviationSubmit.form.preview.film.subtitle')}
        </div>
      </div>
    </div>
  );
};
FakeFilmThumb.displayName = 'FakeFilmThumb';

export default FakeFilmThumb;
